const translations = {
    lastActivity: 'Last Activity',
    lastEdited: 'Last Edited',
    loading: 'Loading',
    name: 'Name',
    noApplications: 'No Applications',
    noMoreApplications: 'No More Applications',
    status: 'Status'
};

export default translations;
